import React, { useEffect, useState } from 'react';
import Tree from './Tree';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { DownOutlined } from '@ant-design/icons';

interface TreeNode {
  id: string | number;
  title: string;
  url?: string;
  children?: TreeNode[];
}

interface TreeMenuProps {
  dataTree: TreeNode[];
  defaultActiveNode?: TreeNode;
}

function TreeMenu({ dataTree, defaultActiveNode }: TreeMenuProps) {
  const [activeNode, setActiveNode] = useState<TreeNode | null | undefined>(defaultActiveNode || null);
  const location = useLocation();

  const calculateHeight = function () {
    const boundMenu = document.querySelector('.master-setting-menu-tree') as HTMLElement;
    if (boundMenu) {
      boundMenu.style.height = boundMenu.getBoundingClientRect().height + 'px';
      const firstChild: any = boundMenu.firstChild;
      if (firstChild) {
        firstChild.classList.remove('hidden');
      }
    }
  };

  useEffect(() => {
    setActiveNode(defaultActiveNode);
  }, [defaultActiveNode]);

  useEffect(() => {
    let node: TreeNode | null = null;
    const pathname = location.pathname;

    function processTreeNode(treeNode: TreeNode) {
      if (treeNode.url && pathname.includes(treeNode.url)) {
        node = treeNode;
        return;
      }
      treeNode.children?.forEach(processTreeNode);
    }

    dataTree.forEach(processTreeNode);
    setActiveNode(node);
  }, [location, dataTree]);

  useEffect(() => {
    document.title = activeNode?.title ? `CMS | ${activeNode.title}` : 'CMS Ôn luyện và Hỏi đáp';
  }, [activeNode]);

  useEffect(() => {
    calculateHeight();
  }, []);

  return (
    <div className="w-full h-full flex gap-4">
      <div className="menu-feature w-[15%] bg-white master-setting-menu-tree overflow-auto">
        <div className="p-3 hidden">
          <Tree
            dataTree={dataTree}
            renderTreeItem={(treeItem: any) => {
              return treeItem.url ? (
                <Link
                  to={treeItem.url}
                  className={
                    'hover:bg-[#e6f8ff] p-2 block rounded text-left relative ' +
                    (activeNode?.id === treeItem.id ? 'bg-[#e6f8ff]' : 'bg-[#f1f1f1dd]')
                  }
                  onClick={() => setActiveNode(treeItem)}
                >
                  {treeItem.title}
                  {treeItem.children && treeItem.children.length > 0 ? (
                    <DownOutlined className="absolute right-2 top-[50%] w-3 h-3 translate-y-[-50%]" />
                  ) : null}
                </Link>
              ) : (
                <div className="hover:bg-[#e6f8ff] p-2 block rounded text-left bg-[#f1f1f1dd] relative">
                  {treeItem.title}
                  {treeItem.children && treeItem.children.length > 0 ? (
                    <DownOutlined className="absolute right-2 top-[50%] w-3 h-3 translate-y-[-50%]" />
                  ) : null}
                </div>
              );
            }}
          />
        </div>
      </div>
      <div className="menu-feature flex-1">
        <Outlet></Outlet>
      </div>
    </div>
  );
}

export default TreeMenu;
